<template>
    <div class="page-content">
        <Titlebar :incrustation="'fa-user-circle'" :backPath="'/reports'">
            <h1>{{ $t('reports.reports.logs.title') }}</h1>
        </Titlebar>
        <UiCard>
            <UiTabs @input="handleChange" class="mb-4">
                <UiTab title="Licences" :active="historyType === 'licence'"/>
                <UiTab title="Profils" :active="historyType === 'profile'"/>
            </UiTabs>
            <SuperTable
                ref="tableIdentifications"
                :tableColumns="tableColumns"
                :tableData="tableData ? tableData : []"
                @sort="handleSort"
                @filter="handleFilter"
                :loading="!tableData"
            />
        </UiCard>
        <Toolbar>
            <div class="row">
                <div class="col">
                </div>
                <div class="col center">
                    <Pagination ref="pagination" @change="handlePagination"></Pagination>
                </div>
                <div class="col">
                    <div class="float-right">
                        <Button 
                            class="default"
                            @click.native.prevent="downloadReport">
                            <span><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;{{ $t('reports.logsTable.download') }}</span>
                            <LoadingMini ref="loading"></LoadingMini>
                        </Button>
                    </div>
                </div>
            </div>
        </Toolbar>
    </div>
</template>

<script>
import axios from "axios";
import API from "@/services/API";
import Titlebar from '@/components/ui/Titlebar';
import Globals from "@/services/globals.js";
import Toolbar from "@/components/ui/Toolbar";
import UiCard from "@/components/ui/Card";
import Pagination from "@/components/ui/Pagination";
import SuperTable from "@/components/ui/Table";
import Button from "@/components/ui/Button";
import LoadingMini from "@/components/ui/LoadingMini";
import { UiTabs, UiTab } from '@/components/ui/ui-tabs';
import {mixin as clickaway} from 'vue-clickaway';
import { getLicenceHistoryColumns, getProfileHistoryColumns } from "@/components/reports/columns";
import moment from 'moment'
import {useDvFlagAccess} from "../../services/featureFlag";

export default {
    name: 'PlatformHistory',
    components: {
        Titlebar,
        Toolbar,
        Pagination,
        SuperTable,
        Button,
        LoadingMini,
        UiCard,
        UiTabs, 
        UiTab
    },
    mixins: [
        clickaway
    ],
  mounted() {
    if (!useDvFlagAccess("beepiz-report-can:read")) {
      this.$router.push({ name: 'AccessDenied', params: { slug: 'reports'} })
    }
  },
  data: () => ({
        historyTypes: ['licence', 'profile'], // In tab orders
        historyType: undefined,
        baseConfig: {
            perpage: Globals.perPage,
            fields: [],
            page: 1,
            filter: {
                like: [],
                equals: [],
            },
            sort: ["-date"],
        },
        currentConfig: {},
        tableColumns: {
            global: {
                sortable: false,
                noItemsMsg: window.V.$i18n.t("reports.logsTable.emptyTable"),
            },
            columns: [],
            rowActions: {},
        },
        tableData: null,
        historyEndpoint: undefined,
        showDownloadPopover: false
    }),
    methods: {
        handleChange: function(newTabIndex) {
            this.historyType = this.historyTypes[newTabIndex]
        },
        toggleShowDownloadPopover: function () {
            if (this.showDownloadPopover) {
                this.showDownloadPopover = false;
            } else {
                this.showDownloadPopover = true;
            }
        },
        handlePagination: function (page) {
            this.currentConfig.page = page;
            this.loadData();
        },
        handleSort: function () {
            this.currentConfig.page = 1;
            this.currentConfig.sort = [];
            for (var colKey in this.tableColumns.columns) {
                var col = this.tableColumns.columns[colKey];
                if (col.activeSort) {
                    this.currentConfig.sort.push(col.activeSort + col.key);

                    if (col.key === "event_state") {
                        this.currentConfig.sort.push(col.activeSort + 'event_state_diag');
                    }
                }
            }
            this.loadData();
        },
        handleFilter: function () {
            this.currentConfig.page = 1;
            this.currentConfig.filter.like = [];
            this.currentConfig.filter.equals = [];
            for (var colKey in this.tableColumns.columns) {
                var col = this.tableColumns.columns[colKey];
                if (col.activeFilter != "" && col.activeFilter !== undefined) {
                    if (col.filter && col.filter.type == "text") {
                        this.currentConfig.filter.like.push(col.key + ":" + col.activeFilter);
                    }
                    if (col.filter && col.filter.type == "list") {
                        this.currentConfig.filter.equals.push(col.key + ":" + col.activeFilter);
                    }
                }
            }
            this.loadData();
        },
        loadData: function () {
            this.tableData = null;
            axios
                .get(this.historyEndpoint + API.constructQueryParams(this.currentConfig))
                .then(response => {
                    this.tableData = response.data.data;
                    this.$refs.pagination.update(response.data.meta.pagination);
                })
                .catch(error => console.log(error))
        },
        downloadReport: function () {
            this.$refs.loading.show();
            axios
                .get(this.historyEndpoint, {
                    responseType: 'blob',
                    headers: {
                        'Accept': 'application/vnd.ms-excel'
                    }
                })
                .then(response => {
                    const currentDate = moment().format("DDMMYYYY");
                    const filename = window.V.$i18n.t(`reports.logsTable.filename.${this.historyType}`, { date: currentDate });
                    const newBlob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
                    const data = window.URL.createObjectURL(newBlob);
                    var link = document.createElement('a');
                    document.body.appendChild(link);
                    link.href = data;
                    link.download = filename;
                    link.click();
                    setTimeout(function () {
                        window.URL.revokeObjectURL(data);
                    }, 100)
                })
                .catch(error => console.log(error))
                .finally(() => {
                    this.$refs.loading.hide();
                    this.showDownloadPopover = false;
                })
        },
        getHistoryType: function() {
            return this.historyTypes.includes(this.$route.query.history ?? '') ? this.$route.query.history : 'licence'
        }
    },
    created(){
        this.historyType = this.getHistoryType();
    },
    watch: {
        historyType: function() {
            // Change endpoint url
            const endpointMap = {
                licence: API.endpoints.reports.licence,
                profile: API.endpoints.reports.profile
            };
            this.historyEndpoint = endpointMap[this.historyType];

            // Change table config & change columns config
            const columnsConfigMap = {
                licence: getLicenceHistoryColumns(window),
                profile: getProfileHistoryColumns(window)
            }
            this.currentConfig = { ...this.baseConfig };
            this.tableColumns.columns = columnsConfigMap[this.historyType]

            this.loadData();
        }
    }
}
</script>

<style lang="scss">

</style>
